export default __webpack_public_path__ + "static/media/line-right-bottom.a3977620.svg";